<aside class="sidebar" [class.collapsed]="sidebarCollapsed">
  <nav class="sidebar-nav">
    <aio-navigation
      ariaLabel="Main"
      [items]="libraryNavItems"
      [selectionFollowsClick]="false"
      [collapsed]="sidebarCollapsed"
      (itemPress)="onNavPress($event)"
      (itemHover)="onNavHover($event)"
      (itemLeave)="onParentLeave()"
    />
  </nav>

  <aio-footer
    class="sidebar-footer"
    ariaLabel="Help"
    [links]="helpFooterLinks"
    [collapsed]="sidebarCollapsed"
  />

  <app-coming-soon-feature-modal
    [isOpen]="comingSoonModalOpen"
    [featureLabel]="comingSoonFeatureLabel"
    (close)="onComingSoonModalClose()"
    (notifyMe)="onComingSoonNotifyMe()"
  />
</aside>
